const escLocale = {
  esc: {
    mandatoryInstallation: "Bailleur IO",
    mandatoryInstallationDesc: "Le site est dans une opération bailleur IO",
    cardTitle: "Statut de l'acquisition",
    modalTitle: "Devis CEE",
    modalActionStep:
      "Vous allez démarrer le processus de signature de devis CEE pour ce site. Merci de vérifier l'éligibilité du site. Un devis sera généré et transmis par mail à l'adhérent.",
    modalSignStep:
      "Vous devez avoir reçu le devis vous précisant la gratuité du dispositif par e-mail, nous allons le valider ensemble à l'aide du code reçu par SMS",
    modalSignStepGoToYousign: "Ouvrir Yousign",
    otherAction: "Je veux effectuer une autre action",
    startSignature: "Lancer la signature",
    checkSignature: "Je valide la signature",
    withdrawalPeriod: "Délais de rétractation",
    interAllowedFrom: "Intervention autorisée à partir du :",
    periodReached: "Délai atteint",
    warnings: {
      globalEscWarning: "UN DEVIS CEE EST A FAIRE SIGNER POUR CE SITE",
      noneElectricityBillHaveOcrSuccess:
        "Impossible d’analyser les factures d’électricités. Les documents fournis n’ont pas pu être reconnus automatiquement par l'OCR.",
      someElectricityBillHaveOcrFailed:
        "Certaines factures d'éléctricités n'ont pas pu être reconnus automatiquement par l'OCR.",
      hasNoElectricityBill: "Une facture d'électricité est attendue pour ce site",
      someElectricityBillsHaveUncontrolledState: "Une ou plusieurs facture d'électricité sont en attente de validation",
      allElectricityBillsHaveOcrFailed:
        "Les factures d'électricité uploadées n’ont pas été jugées conformes. Une facture d'électricité conforme est attendue pour ce site",
      documentIsNotSignedYet: "Le document n'est toujours pas signé",
      escQuoteInProgressButNotSigned: "Devis CEE en cours mais non signé, merci de reprendre le parcours de signature",
      subscriberEligible: "Adhérent éligible à la prime CEE, merci de reprendre le parcours de signature",
      incorrectFields: "Certains champs ne sont pas compatibles avec l'éligibilité CEE",
      fields: {
        surface: "Surface invalide",
        subscriber: "Adhérent manquant",
        subscriberCompany: "Le site est un site commercial/tertiaire",
        mandatoryInstallation: "Le site est dans une opération bailleur IO",
        isNotInFrance: "Le site n'est pas localisé en France métropolitaine",
      },
    },
    toasts: {
      quoteSentSuccess: "Le devis a été envoyé à l'adhérent par mail",
      quoteSentError: "Une erreur est survenue lors de la génération du devis",
    },
    escEligibility: "Éligible CEE",
    escQuoteSigned: "Devis CEE signé",
    continueFlow: "Reprendre le parcours",
    generateQuote: "Générer un devis",
    restartQuoteProcess: "Relancer le processus de signature de devis",
    // Folder details view
    generalInformation: "Informations générales du dossier CEE",
    escStatus: "Statut ESC",
    escStatusEligible: "Éligible ESC",
    escStatusNonEligible: "Non éligible ESC",
    escStatusNotDetermined: "Statut non déterminé",
    phase: "Phase",
    escVersionLabel: "Information sur la version CEE",
    escVersionTooltip: "Indique la phase/itération CEE du dossier.",
    engagementDateLabel: "Information sur la date d'engagement",
    engagementDateTooltip: "Date d'engagement officielle du dossier CEE auprès de l'organisme certificateur.",
    escTypes: "Types ESC",
    escTypesInfo: "Information sur les types ESC",
    escTypesDescription: "Liste des fiches d'opérations standardisées CEE actives pour ce dossier.",
    noEscTypesProvided: "Aucun type renseigné",
    folderProgress: "Progression du dossier",
    folderActions: "Actions disponibles sur le dossier",
    actionsHistory: "Historique des actions",
    displayMode: "Mode d'affichage",
    displayModeList: "Liste",
    displayModeHierarchy: "Hiérarchie",
    applications: "Applications",
    allApplications: "Toutes",
    actors: "Acteurs",
    allActors: "Tous",
    clearFilters: "Réinitialiser",
    noEventsMatched: "Aucun événement ne correspond aux filtres sélectionnés.",
    folderLoadError: "Erreur lors du chargement du dossier CEE",
    noFolderAvailable: "Aucun dossier CEE disponible pour ce site",
    selectedCount: "{count} application | {count} applications",
    selectedActorCount: "{count} acteur | {count} acteurs",
    eventDetails: "Voir les détails",
    eventDetailsKeys: "{count} clé | {count} clés",
    system: "Système",
    systemAction: "Action système",
    userId: "ID : {id}",
    user: "Utilisateur",
    userWithId: "Utilisateur {id}",
    systemLabel: "Système",
    systemTooltip: "Action système",
    userLabel: "Utilisateur {id}",
    userIdTooltip: "ID : {id}",
    profileLabel: "Profil",
    idLabel: "ID",
    // Action type labels
    actionTypeCaseMigration: "Migration du dossier",
    actionTypeCreated: "Création du dossier",
    actionTypeEligibilityCheck: "Vérification éligibilité",
    actionTypeGenerateEstimate: "Génération devis",
    actionTypeGenerateInvoice: "Génération facture",
    actionTypeSendReminder: "Envoi rappel",
    actionTypeGenerateEscInstallationPackage: "Package installation ESC",
    actionTypeGenerateInstallationPackage: "Package installation",
    actionTypeGenerateMaintenancePackage: "Package maintenance",
    actionTypeGenerateTransferForm: "Formulaire de transfert",
    actionTypeGenerateCustomerServiceCertificate: "Attestation SAV",
    actionTypeCancelSignature: "Annulation signature",
    actionTypeCancelAllSignatures: "Annulation signatures",
    actionTypeRegenerateDocument: "Régénération signature",
    actionTypeSwitchToSale: "Bascule provision à vente",
    actionTypeError: "Erreur",
    actionTypeDocumentSigned: "Document signé",
    actionTypeGenerateCreditNote: "Génération avoir",
    actionTypeEndpointUsed: "Endpoint utilisé",
    // Contextual action labels
    actionDownloadDocument: "Télécharger le document",
    actionCancelSignature: "Annuler la signature",
    actionSendReminder: "Relancer le signataire",
    actionViewDetails: "Voir les détails",
    actionViewError: "Voir l'erreur",
    actionRegenerateDocument: "Régénérer le document",
    actionSwitchToSale: "Basculer en vente",
    actionCancelAllSignatures: "Annuler toutes les signatures",
    // Contextual action toasts
    contextualAction: {
      success: "Action exécutée avec succès",
      error: "Une erreur est survenue lors de l'exécution de l'action",
    },
  },
};

export default escLocale;
